import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Avatar, Popover } from "antd";
const UserInfo = () => {
    const userMenuOptions = (_jsxs("ul", Object.assign({ className: "gx-user-popover" }, { children: [_jsx("li", { children: "My Account" }), _jsx("li", { children: "Connections" })] })));
    return (_jsx(Popover, Object.assign({ overlayClassName: "gx-popover-horizantal", placement: "bottomRight", content: userMenuOptions, trigger: "click" }, { children: _jsx(Avatar, { src: "https://via.placeholder.com/150", className: "gx-avatar gx-pointer", alt: "" }) })));
};
export default UserInfo;
